import React, { Component } from 'react';

import { MyInput } from '../elements/MyInput';
import { GhoreTable } from '../tables/ghore/GhoreTable'
import { GhorePrizePage } from './GhorePrizePage'

import { SelectPrizeForGhore } from '../tables/selectPrizeForGhore/SelectPrizeForGhore'
import { CeremonyTable } from '../tables/ceremony/CeremonyTable'

import {CeremonyPage} from "./CeremonyPage"

export class GhoreKeshi extends Component {


  constructor(props) {
    super(props);
    this.state = { currentCount: 0, isLoading: false };
    this.state.data = {};
    //  this.incrementCounter = this.incrementCounter.bind(this);
    this.onFormChange = this.onFormChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.onPrizeClick = this.onPrizeClick.bind(this);
    this.onGhoreClick = this.onGhoreClick.bind(this);

    this.onHideMasterPage = this.onHideMasterPage.bind(this);

    this.onAddCeremony=this.onAddCeremony.bind(this);

    var token = localStorage.getItem('token');
    this.headers =
    {
      'Content-Type': 'application/json',
      'AuthorizationToken': token
    };
  }
S
  onPrizeClick(e) {

    this.state.mode = "prize";
    this.state.ghoreId = e;
    this.setState({});

  }
  handleSubmit(e) {
    e.preventDefault();

    var data = this.state.data;
    console.log(data);

    this.setState({ isLoading: true });

    fetch('api/v1/AddGhore',
      {
        method: 'POST',
        body: JSON.stringify(data),
        headers: this.headers
      }).then(res => {
        this.status = res.status;

        res.json().then((result) => {
          //  console.log(result);

          if (this.status == 200) {
            alert('OK');
          }
          else {
            console.log(result);
            alert(result.Value);

          }
          this.setState({ isLoading: false });
          this.setState({});
        },
          (error) => {
            this.setState({ isLoading: false });
          }
        );
      }
      );


  }
  onFormChange() {

  }

  handleTextChange(e, key) {
    //   console.log(e);
    this.state.data[key] = e;
    this.setState({});
  }

  onGhoreClick(e) {

    this.state.mode = "ghore";
    this.state.ghoreId = e;
    this.setState({});


  }

  onAddCeremony()
  {
    console.log("onAddCeremony");
    this.setState({mode:""});
  }



  onHideMasterPage(data, type) {

    if (typeof this.props.onHideMasterPage === "function") {
      this.props.onHideMasterPage(data, type);

    }

  }


  render() {
    if (this.state.isLoading) {
      return <div>...</div>
    }

    if (this.state.mode == "prize") {
      return (<GhorePrizePage ghoreId={this.state.ghoreId}></GhorePrizePage>)
    }


    if (this.state.mode == "ghore")
     {
       return(
         <CeremonyPage ghoreId={this.state.ghoreId} onAdd={this.onAddCeremony} onHideMasterPage={this.onHideMasterPage} />
       )
    }

    return (
      <div >



        <GhoreTable onPrizeClick={this.onPrizeClick} onGhoreClick={this.onGhoreClick}>

        </GhoreTable>



        <hr />

        <div className="row">
          <div className="col-md-4">
          </div>
          <div className="col-md-4 col-sm-12">

            <form className="" onSubmit={this.handleSubmit} ref="myRef">
              <MyInput onChange={this.handleTextChange} label="عنوان" name="Name" ></MyInput>
              <br />
              <MyInput onChange={this.handleTextChange} label="توضیحات" name="Description" ></MyInput>
              <br />
              <button className="btn btn-primary" onClick={this.handleSubmit}>اضافه کردن</button>
              <br />
            </form>
          </div>
          <div className="col-md-4">
          </div>


        </div>


      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GhoreKeshi.js